import React from 'react';
import { Box, Typography, Fab } from "@mui/material";
import { MessageCircle, FileText, X, Plus } from 'lucide-react';
import { fabStyle } from "../lib/uiformatting";

export default function PortalFabMenu({ navigate }) {
    const [fabOpen, setFabOpen] = React.useState(false);

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 24,
                right: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: 1.5,
                zIndex: 1000,
            }}
        >
            {/* Menu Options */}
            {fabOpen && (
                <>
                    {/* Text Us Option */}
                    <Box
                        component="a"
                        href="sms:+17816504492"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            backgroundColor: 'white',
                            borderRadius: '50px',
                            py: 1.5,
                            px: 2.5,
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            cursor: 'pointer',
                            textDecoration: 'none',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            animation: 'fadeSlideUp 0.2s ease-out forwards',
                            '@keyframes fadeSlideUp': {
                                '0%': {
                                    opacity: 0,
                                    transform: 'translateY(10px)',
                                },
                                '100%': {
                                    opacity: 1,
                                    transform: 'translateY(0)',
                                },
                            },
                            '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                            },
                        }}
                        onClick={() => setFabOpen(false)}
                    >
                        <Box
                            sx={{
                                backgroundColor: '#dbeafe',
                                borderRadius: '50%',
                                p: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <MessageCircle size={24} color="#2563eb" />
                        </Box>
                        <Typography sx={{ fontWeight: 600, color: '#1a1a2e', fontSize: '0.85rem' }}>
                            Text Us
                        </Typography>
                    </Box>

                    {/* New Visit Option */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                            backgroundColor: 'white',
                            borderRadius: '50px',
                            py: 1.5,
                            px: 2.5,
                            mb: 10,
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            cursor: 'pointer',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            animation: 'fadeSlideUpDelayed 0.2s ease-out 0.05s forwards',
                            opacity: 0,
                            '@keyframes fadeSlideUpDelayed': {
                                '0%': {
                                    opacity: 0,
                                    transform: 'translateY(10px)',
                                },
                                '100%': {
                                    opacity: 1,
                                    transform: 'translateY(0)',
                                },
                            },
                            '&:hover': {
                                transform: 'scale(1.02)',
                                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                            },
                        }}
                        onClick={() => {
                            setFabOpen(false);
                            navigate("/returning-patient", { state: { portal: true } });
                        }}
                    >
                        <Box
                            sx={{
                                backgroundColor: '#d1fae5',
                                borderRadius: '50%',
                                p: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <FileText size={24} color="#059669" />
                        </Box>
                        <Typography sx={{ fontWeight: 600, color: '#1a1a2e', fontSize: '0.85rem' }}>
                            New Visit
                        </Typography>
                    </Box>
                </>
            )}

            {/* Main FAB */}
            <Fab
                aria-label={fabOpen ? "close menu" : "open menu"}
                sx={{
                    ...fabStyle,
                    position: 'relative',
                    backgroundColor: '#1a3a5c',
                    color: 'white',
                    '&:hover': {
                        backgroundColor: '#2a4a6c',
                    },
                    ...(!fabOpen && {
                        animation: 'pulse 5s ease-in-out infinite',
                        '@keyframes pulse': {
                            '0%, 100%': {
                                transform: 'scale(1)',
                                boxShadow: '0 0 0 0 rgba(26, 58, 92, 0.7)',
                            },
                            '50%': {
                                transform: 'scale(1.05)',
                                boxShadow: '0 0 0 10px rgba(26, 58, 92, 0)',
                            },
                        },
                    }),
                }}
                onClick={() => setFabOpen(!fabOpen)}
            >
                {fabOpen ? <X size={24} /> : <Plus size={24} />}
            </Fab>
        </Box>
    );
}
